@if (!clientStatusService.isMobile) {
  <div class="task-list-entry">
    <sc-selectable-tile [style]="selected ? 'selected' : 'default'">
      <sc-padding>
        <sc-flex>
          <div class="icon">
            @if (task.type === taskType.CHECK) {
              <sc-icon iconClass="fa-shield-check" large></sc-icon>
            }
            @if (task.type === taskType.DOCUMENT) {
              <sc-icon iconClass="fa-file" large></sc-icon>
            }
            @if (task.type === taskType.PICTURE) {
              <sc-icon iconClass="fa-camera" large></sc-icon>
            }
          </div>
          <sc-content-spacer></sc-content-spacer>
          <sc-text-label labelDictionaryKey="tmc-yard.ui.task-assignment-dialog.name" [labelDictionaryKey]="task.nameDictionaryKey"
          class="name-field"></sc-text-label>
          <sc-content-spacer></sc-content-spacer>
          <sc-text-label labelDictionaryKey="tmc-yard.ui.task-assignment-dialog.relevance"
          labelDictionaryKey="tmc-yard.ui.task-assignment-dialog.relevance.{{task.relevance}}"></sc-text-label>
          <sc-content-spacer grow></sc-content-spacer>
          <div class="status">
            @if (task.done) {
              <sc-icon iconClass="fa-check" large></sc-icon>
            }
            @if (task.important && !task.done) {
              <sc-icon iconClass="fa-exclamation-triangle important" large></sc-icon>
            }
          </div>
        </sc-flex>
      </sc-padding>
    </sc-selectable-tile>
  </div>
}
@if (clientStatusService.isMobile) {
  <div class="task-list-entry-mobile">
    <sc-selectable-tile [style]="selected ? 'selected' : 'default'">
      <sc-padding>
        <sc-flex>
          <div class="icon">
            @if (task.type === taskType.CHECK) {
              <sc-icon iconClass="fa-shield-check"></sc-icon>
            }
            @if (task.type === taskType.DOCUMENT) {
              <sc-icon iconClass="fa-file"></sc-icon>
            }
            @if (task.type === taskType.PICTURE) {
              <sc-icon iconClass="fa-camera"></sc-icon>
            }
          </div>
          <sc-content-spacer></sc-content-spacer>
          <div>
            <div><sc-dictionary-label [dictionaryKey]="task.nameDictionaryKey"></sc-dictionary-label></div>
            <div class="relevance"><sc-dictionary-label
            [dictionaryKey]="'tmc-yard.ui.task-assignment-dialog.relevance.' + task.relevance"></sc-dictionary-label>
          </div>
        </div>
        <sc-content-spacer grow></sc-content-spacer>
        <div class="status">
          @if (task.done) {
            <sc-icon iconClass="far fa-check"></sc-icon>
          }
          @if (task.important && !task.done) {
            <sc-icon iconClass="far fa-exclamation-triangle important"></sc-icon>
          }
        </div>
      </sc-flex>
    </sc-padding>
  </sc-selectable-tile>
</div>
}
